import Buttons from '@klv/molecules/buttons';
import { Wrapper } from '@klv/utils/wrapper';
import { generateClassName } from '@klv/shared/utils/functions';
import { getBackgroundType } from '@klv/utils/wrapper/functions';
import { LIGHT_BACKGROUNDS } from '@klv/shared/utils/variables';

import * as styles from './styles/fullColumn.module.scss';
import type { IFullColumn } from './types';

const FullColumn = ({
  backgroundColor = 'charcoal',
  buttons = [],
  customPadding = { customPaddingBottom: 'default', customPaddingTop: 'default' },
  eyebrow = '',
  headline = '',
  headlineFont,
  image = {},
  mobileImage = {},
  paragraph,
  variant = 'textRight',
  fadeIn = false,
}: IFullColumn) => {
  const { fontFamily = 'sohne' } = headlineFont || {};
  const hasMobileImage = Boolean(mobileImage?.sourceUrl);
  const hasImage = Boolean(image?.sourceUrl);
  const backgroundType = getBackgroundType(backgroundColor);
  const background = LIGHT_BACKGROUNDS.concat('light').includes(backgroundColor) ? 'poppy' : 'lemon';

  const schmal = fontFamily === 'sohne-schmal' ? styles.schmal : '';

  return (
    <Wrapper
      customPadding={customPadding}
      backgroundColor={backgroundColor}
      contained={false}
      fadeIn={fadeIn ? 0.25 : 0}
    >
      <div>
        <div className={styles.fullColumnContent}>
          {hasImage && (
            <img
              alt={image.altText}
              className={styles.image}
              height={image?.mediaDetails?.height || 392}
              sizes="(min-width: 768px) 1366px, 100vw"
              src={image.sourceUrl}
              srcSet={image.srcSet}
              width={image?.mediaDetails?.width || 588}
            />
          )}
          {hasMobileImage && 
            <img
              alt={mobileImage.altText}
              className={styles.mobileImage}
              height={mobileImage?.mediaDetails?.height || 392}
              sizes="100vw"
              src={mobileImage.sourceUrl}
              srcSet={mobileImage.srcSet}
              width={mobileImage?.mediaDetails?.width || 588}
            />
          }

          <div className={generateClassName(['grid', styles.oneColumnGrid])}>
            {eyebrow && (
              <div className={`eyebrow ${styles.eyebrow} ${styles[variant]}`}>{eyebrow}</div>
            )}
          </div>

          <div className={generateClassName(['grid', `${styles.grid} ${styles[variant]}`])}>
            {headline && (
              <h2 className={`h3 ${styles.headline} ${styles[variant]} ${schmal}`}>{headline}</h2>
            )}

            <div className={`p2 ${styles.mainContent} ${styles[variant]}`}>
              <p
                className={generateClassName([styles.bodyCopy, styles[background]])}
                dangerouslySetInnerHTML={{ __html: paragraph }}
              />
              {buttons && buttons.length > 0 && 
                <div className={styles.buttons}>
                  <Buttons
                    buttonColor={backgroundType === 'light' ? 'dark' : 'light'}
                    buttons={buttons}
                    variants={['ghost', 'tertiary']}
                  />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default FullColumn;
